import React from 'react';
import { commonStyles } from '../../styles/common';
import { Users, LineChart, Shield, Building } from 'lucide-react';

const Process = () => {
  return (
    <section className={`${commonStyles.section} bg-white`}>
      <div className={commonStyles.container}>
        <h2 className={commonStyles.heading.primary}>Comment fonctionne le dispositif CEE ?</h2>
        
        <div className="grid md:grid-cols-2 gap-8 mt-8">
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <Users className="w-6 h-6 text-blue-600 mr-2" />
              Une obligation pour les entreprises énergétiques
            </h3>
            <ul className="space-y-2 text-gray-600">
              <li>• Les grandes entreprises doivent générer des économies d'énergie</li>
              <li>• Ces économies sont mesurées en "kWh cumac"</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <LineChart className="w-6 h-6 text-blue-600 mr-2" />
              Un soutien financier pour les projets
            </h3>
            <ul className="space-y-2 text-gray-600">
              <li>• Les travaux éligibles génèrent des CEE</li>
              <li>• Ces CEE permettent de financer une partie des coûts</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <Shield className="w-6 h-6 text-blue-600 mr-2" />
              Des acteurs variés
            </h3>
            <ul className="space-y-2 text-gray-600">
              <li>• Les obligés : Entreprises responsables</li>
              <li>• Les délégataires : Tiers gestionnaires</li>
              <li>• Les éligibles : Acteurs pouvant obtenir des CEE</li>
            </ul>
          </div>
          
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4 flex items-center">
              <Building className="w-6 h-6 text-blue-600 mr-2" />
              Un rôle de l'État
            </h3>
            <ul className="space-y-2 text-gray-600">
              <li>• Supervision du dispositif</li>
              <li>• Contrôles réguliers</li>
              <li>• Sanctions en cas de non-respect</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;